module.exports = __webpack_public_path__ + "static/pillow-2-e6bc32829d4d658e8c90b3527aabb30c.png";